// Ant Design theme tokens — mirrors src/styles/_common.scss
// This file exists ONLY because Ant Design's ConfigProvider needs JS strings.
// ALL color definitions live in _common.scss. When you change a color, update
// _common.scss first, then sync the affected value here.

export const colors = {
  brandGold:   '#E5C100',
  pageBg:      '#121826',
  cardBg:      '#1F2937',
  cardBorder:  '#414756',
  rowHoverBg:  '#2C3E50',
  messageBg:   '#2d3b50',
} as const;
